/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  // Add custom code below this line

 (function () {

  const SELECTORS = {
    form: '[data-cart-discount-form]',
    input: '[data-cart-discount-input]',
    submit: '[data-cart-discount-submit]',
    message: '[data-cart-discount-message]',
    applied: '[data-cart-discount-applied]',
    appliedCode: '[data-cart-discount-code]',
    remove: '[data-cart-discount-remove]',
    priceHolder: '[data-cart-price-holder]'
  };


  /*
   * Găsește formularul de discount vizibil.
   *
   * Avem unul în Cart Drawer și unul pe pagina /cart.
   */
  function getVisibleForm() {

    const forms = Array.from(
      document.querySelectorAll(
        SELECTORS.form
      )
    );

    return forms.find(function (form) {

      const style =
        window.getComputedStyle(form);

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        form.offsetParent !== null
      );

    }) || forms[0];
  }


  /*
   * Actualizare pentru Cart Drawer.
   *
   * Pe pagina /cart NU folosim această funcție.
   * Acolo facem refresh normal al paginii.
   */
  async function refreshCartDrawer() {

    const response = await fetch(
      window.location.pathname +
      '?sections=cart-drawer',
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      }
    );


    if (!response.ok) {
      throw new Error(
        'Cart Drawer refresh failed.'
      );
    }


    const sections =
      await response.json();


    const drawerHTML =
      sections['cart-drawer'];


    if (!drawerHTML) {
      throw new Error(
        'Cart Drawer section not found.'
      );
    }


    const parser =
      new DOMParser();


    const doc =
      parser.parseFromString(
        drawerHTML,
        'text/html'
      );


    const newPriceHolder =
      doc.querySelector(
        SELECTORS.priceHolder
      );


    /*
     * Căutăm Cart Drawer-ul.
     */
    const drawer =
      document.querySelector(
        '#cart-drawer'
      );


    const currentPriceHolder =
      drawer
        ? drawer.querySelector(
            SELECTORS.priceHolder
          )
        : null;


    if (
      newPriceHolder &&
      currentPriceHolder
    ) {

      currentPriceHolder.innerHTML =
        newPriceHolder.innerHTML;
    }

  }


  /*
   * Afișează codul aplicat.
   */
  function showAppliedCode(code) {

    const form =
      getVisibleForm();

    if (!form) return;


    const applied =
      form.querySelector(
        SELECTORS.applied
      );


    const appliedCode =
      form.querySelector(
        SELECTORS.appliedCode
      );


    if (
      applied &&
      appliedCode
    ) {

      appliedCode.textContent =
        code;

      applied.hidden = false;
    }

  }


  /*
   * Ascunde codul aplicat.
   */
  function hideAppliedCode() {

    const form =
      getVisibleForm();

    if (!form) return;


    const applied =
      form.querySelector(
        SELECTORS.applied
      );


    if (applied) {
      applied.hidden = true;
    }

  }


  /*
   * APLICĂ DISCOUNT
   */
  async function applyDiscount() {

    const form =
      getVisibleForm();

    if (!form) return;


    const input =
      form.querySelector(
        SELECTORS.input
      );


    const button =
      form.querySelector(
        SELECTORS.submit
      );


    const message =
      form.querySelector(
        SELECTORS.message
      );


    if (!input || !button) {
      return;
    }


    const discountCode =
      input.value.trim();


    /*
     * Nu trimitem cod gol.
     */
    if (!discountCode) {

      if (message) {
        message.textContent =
          'Introdu un cod de reducere.';
      }

      return;
    }


    /*
     * Dezactivăm butonul cât timp
     * Shopify procesează codul.
     */
    button.disabled = true;

    button.textContent =
      'SE APLICĂ...';


    if (message) {
      message.textContent = '';
    }


    try {

      /*
       * Trimitem codul către Shopify.
       */
      const response = await fetch(
        window.Shopify.routes.root +
        'cart/update.js',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            'Accept':
              'application/json'
          },

          body: JSON.stringify({
            discount: discountCode
          })
        }
      );


      if (!response.ok) {
        throw new Error(
          'Discount update failed.'
        );
      }


      /*
       * Shopify ne returnează coșul actualizat.
       */
      const cart =
        await response.json();


      const discountCodes =
        cart.discount_codes || [];


      /*
       * Căutăm codul care chiar a fost acceptat.
       */
      const appliedDiscount =
        discountCodes.find(
          function (discount) {
            return discount.applicable;
          }
        );


      /*
       * Dacă Shopify nu a acceptat codul.
       */
      if (!appliedDiscount) {

        if (message) {
          message.textContent =
            'Codul nu este valid sau nu se aplică acestui coș.';
        }

        return;
      }


      /*
       * Codul a fost aplicat cu succes.
       */
      showAppliedCode(
        appliedDiscount.code
      );


      /*
       * Golim câmpul.
       */
      input.value = '';


      /*
       * PE PAGINA /CART
       *
       * Facem refresh normal.
       *
       * Shopify va reda automat:
       * - subtotalul
       * - reducerea
       * - totalul
       * - codul de discount
       */
      if (
        window.location.pathname === '/cart'
      ) {

        window.location.reload();

        return;
      }


      /*
       * În Cart Drawer încercăm
       * să actualizăm fără refresh.
       */
      try {

        await refreshCartDrawer();

      } catch (refreshError) {

        console.warn(
          'Cart Drawer visual refresh failed:',
          refreshError
        );

      }


      if (message) {
        message.textContent = '';
      }


    } catch (error) {

      console.error(
        'Discount error:',
        error
      );


      if (message) {
        message.textContent =
          'Codul nu a putut fi aplicat. Încearcă din nou.';
      }


    } finally {

      button.disabled = false;

      button.textContent =
        'APLICĂ';
    }

  }


  /*
   * ELIMINĂ DISCOUNT
   */
  async function removeDiscount() {

    const form =
      getVisibleForm();

    if (!form) return;


    const button =
      form.querySelector(
        SELECTORS.remove
      );


    const message =
      form.querySelector(
        SELECTORS.message
      );


    if (!button) return;


    /*
     * Dezactivăm X-ul cât timp Shopify
     * procesează eliminarea.
     */
    button.disabled = true;

    button.classList.add(
      'is-removing'
    );


    if (message) {
      message.textContent = '';
    }


    try {

      /*
       * Ștergem codul din Shopify.
       */
      const response = await fetch(
        window.Shopify.routes.root +
        'cart/update.js',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            'Accept':
              'application/json'
          },

          body: JSON.stringify({
            discount: ''
          })
        }
      );


      if (!response.ok) {
        throw new Error(
          'Discount removal failed.'
        );
      }


      /*
       * Shopify a confirmat eliminarea.
       */
      await response.json();


      /*
       * PE PAGINA /CART
       *
       * Refresh normal pentru ca Broadcast
       * să redea totalul fără reducere.
       */
      if (
        window.location.pathname === '/cart'
      ) {

        window.location.reload();

        return;
      }


      /*
       * În Cart Drawer ascundem imediat
       * tag-ul și actualizăm totalul.
       */
      hideAppliedCode();


      try {

        await refreshCartDrawer();

      } catch (refreshError) {

        console.warn(
          'Cart Drawer visual refresh failed:',
          refreshError
        );

      }


    } catch (error) {

      console.error(
        'Remove discount error:',
        error
      );


      if (message) {
        message.textContent =
          'Reducerea nu a putut fi eliminată.';
      }


    } finally {

      button.disabled = false;

      button.classList.remove(
        'is-removing'
      );

    }

  }


  /*
   * CLICK PE APLICĂ
   */
  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          SELECTORS.submit
        );


      if (!button) return;


      event.preventDefault();


      applyDiscount();

    }
  );


  /*
   * CLICK PE X
   */
  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          SELECTORS.remove
        );


      if (!button) return;


      event.preventDefault();


      removeDiscount();

    }
  );


  /*
   * ENTER ÎN CÂMPUL DE COD
   */
  document.addEventListener(
    'keydown',
    function (event) {

      const input =
        event.target.closest(
          SELECTORS.input
        );


      if (!input) return;


      if (
        event.key !== 'Enter'
      ) {
        return;
      }


      event.preventDefault();


      applyDiscount();

    }
  );


  /*
   * Verifică dacă există deja
   * un discount aplicat.
   *
   * Este util când:
   * - dai refresh
   * - intri pe /cart
   * - deschizi Cart Drawer
   */
  async function checkExistingDiscount() {

    const form =
      getVisibleForm();

    if (!form) return;


    try {

      const response =
        await fetch(
          window.Shopify.routes.root +
          'cart.js',
          {
            method: 'GET',

            headers: {
              'Accept':
                'application/json'
            }
          }
        );


      if (!response.ok) {
        return;
      }


      const cart =
        await response.json();


      const discountCodes =
        cart.discount_codes || [];


      /*
       * Găsim primul cod activ.
       */
      const appliedDiscount =
        discountCodes.find(
          function (discount) {
            return discount.applicable;
          }
        );


      if (appliedDiscount) {

        showAppliedCode(
          appliedDiscount.code
        );

      } else {

        hideAppliedCode();

      }


    } catch (error) {

      console.warn(
        'Could not check existing discount:',
        error
      );

    }

  }


  /*
   * Verificăm discountul la încărcarea paginii.
   */
  checkExistingDiscount();


})();

  // Desktop search: sync summary input with popdown field when user types.
  const searchInputField = document.getElementById('custom_search_input');
  const displayField = document.getElementById('SearchInput--desktop');
  const searchIcon = document.querySelector('.custom_search-bar');

  if (!searchInputField || !displayField || !searchIcon) {
    return;
  }

  let firstKeyPending = true;

  searchInputField.addEventListener('keydown', function (e) {
    if (e.key === 'Backspace' || e.ctrlKey || e.metaKey || e.altKey) {
      return;
    }
    if (firstKeyPending && e.key.length === 1) {
      displayField.value += e.key;
      const details = searchIcon.closest('details') || searchIcon.parentElement.querySelector('details');
      if (details && !details.open) {
        details.open = true;
        details.dispatchEvent(new Event('toggle'));
      }
      firstKeyPending = false;
    }
  });

  displayField.addEventListener('keydown', function () {
    searchInputField.value = displayField.value;
    firstKeyPending = true;
  });

})();
